import React, { useEffect, useState } from 'react';
import { Dialog } from '@headlessui/react';
import { faker } from '@faker-js/faker/locale/ko';

type PreschoolType = {
  id: number;
  name: string;
  address: string;
  phone: string;
};

const dummyData = (count: number = 10, ms: number = 1000): Promise<Array<PreschoolType>> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const data = Array.from({ length: count }).map((_, index: number) => {
        return {
          id: index,
          name: faker.name.fullName(),
          address: `${faker.address.cityName()} ${faker.address.cardinalDirection()} ${faker.address.country()}`,
          phone: faker.phone.number('070########'),
        };
      });

      resolve(data);
    }, ms);
  });
};

interface IItemProp {
  readonly preschool: PreschoolType;
  readonly onSelected: (id: number, name: string) => void;
}

/**
 * 어린이집 목록 아이템
 * @param
 * @returns
 */
const PreschoolItem = ({ preschool, onSelected }: IItemProp) => {
  const handleSelected = () => {
    onSelected(preschool.id, preschool.name);
  };

  return (
    <div
      className="flex px-4 min-h-[4rem] cursor-pointer hover:bg-primary hover:text-white group hover:bg-opacity-90"
      onClick={handleSelected}>
      <div className="text-sm flex flex-col justify-center">
        <div className="mb-1 truncate">{preschool.name}</div>
        <div className="text-gray-400 truncate group-hover:text-white/75 font-light">
          {preschool.address}
        </div>
      </div>
    </div>
  );
};

interface IProp {
  readonly isOpen: boolean;
  readonly setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  readonly onClose?: () => void;
  readonly onSelect?: (id: number, name: string) => void;
}

/**
 * 어린이집 선택
 * @param
 * @returns
 */
export const PreschoolSelector = ({ isOpen, setIsOpen, onClose, onSelect }: IProp) => {
  const [preschoolList, setPreschoolList] = useState<Array<PreschoolType>>([]);

  useEffect(() => {
    async function fetchData() {
      const data = await dummyData();
      setPreschoolList(data);
    }

    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const handleSelected = (id: number, name: string) => {
    setIsOpen(false);
    if (onSelect) {
      onSelect(id, name);
    }
  };

  return (
    <Dialog className="relative z-30" open={isOpen} onClose={() => handleClose()}>
      {/* backdrop */}
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      {/* container */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="card w-full md:w-96 rounded-lg bg-white shadow">
          <div className="card-body pt-4 pb-1 px-0">
            <Dialog.Title className="card-title text-base px-4 mb-2">어린이집 찾기</Dialog.Title>
            <div className="form-control px-4 mb-2">
              <input
                type="text"
                className="input input-bordered text-sm tracking-wide"
                placeholder="검색하실 어린이집 이름을 입력해주세요"
              />
            </div>
            <div className="divide-y max-h-[20rem] min-h-[20rem] overflow-y-auto border-y border-gray-200">
              {preschoolList.length === 0 && (
                <div className="text-sm text-center">어린이집 정보를 가져오고 있습니다.</div>
              )}
              {preschoolList.map((preschool: PreschoolType) => {
                return (
                  <PreschoolItem
                    preschool={preschool}
                    key={preschool.id}
                    onSelected={handleSelected}
                  />
                );
              })}
            </div>
            <div className="card-actions justify-end items-center">
              <button className="btn btn-ghost text-sm py-0 font-normal" onClick={handleClose}>
                닫기
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};
